import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { error } from 'highcharts';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';

@Component({
  selector: 'app-edit-scrubber-usage',
  templateUrl: './edit-scrubber-usage.component.html',
  styleUrls: ['./edit-scrubber-usage.component.scss']
})
export class EditScrubberUsageComponent {
  @Input() shipDetailsbasicinfo:any;
  @Input() getScrubberData:any;
  @Output() getupdateScrubberUsage = new EventEmitter();
  @Output() getScrubberUsageLoaderEvent = new EventEmitter();
  @Output() errorScrubberUsageLoaderEvent = new EventEmitter();
  openEditScrubberUsage: boolean = false
  isTextError: boolean = false;
  editScrubberUsageVal: string = 'editScrubberUsageVal_1';
  headerName: string = 'Edit Scrubber Usage'
  toggleScrubberVal: boolean = false;
  showScrubberDiscardBanner: boolean = false;
  maxLength = 300;
  noChangeDate: any;
  scrubberUsageDate_1Val: any;
  scrubberUsageReasonfieldValue_1Val: string = '';
  vesselActivationDate: any;
  getFYdate: any;
  disableFYdate: Date;
  selectedScrubberUsageDate: any;
  scrubberUsageReason: string = '';
  scrubberUsageReasonError: boolean = false;
  updatePayload: { };
  updateScrubberUsageData: any;
  discardScrubberSuccess: boolean = false;
  selectedUpcomingScrubberUsageDate: any;
  upcomingScrubberUsageReason: string = '';
  upcomingScrubberUsageReasonError: boolean = false;
  pendingCurrentEffectiveDate: any;
  pendingCurrentReason: any;
  upComingScrubberDate: any;
  upComingScrubberReason: any;
  openDiscardScrubberUsage:boolean = false;
  discardScrubberUsageData: any;
  pendingScrubberUsageDateVal: any;
  pendingScrubberUsageReason: string = '';
  pendingScrubberUsageReasonError: boolean = false;
  openRestoreScrubberUsage:boolean = false;
  restoreScrubberUsageData: any;
  noChangeScrubberDate: any;
  noChangeScrubberReason: string = '';
  scrubberUsageForm:UntypedFormGroup;
  private readonly decimalPattern = /^[1-9]\d*(?:\.\d{1,2})?$/;
  scrubberUsageVal: any = null;
  searchText:any;
  scrubberPointsUsageErrorMsg: boolean = false;

  private readonly scrubberUsagePointsRequiredMessage = 'Scrubber points are required.';
  private readonly scrubberUsagePointsPatternMessage = 'Please enter a valid decimal input.';
  getToggleValue: boolean = false;
  // openUnsavedScrubberUsage:boolean = false;
  constructor(private vesselService:VesselsService, 
        private toasterService: ToasterService,
         private fb: UntypedFormBuilder,
        private datePipe: DatePipe){
    
  }
  ngOnInit() {
    this.scrubberUsageForm = this.fb.group({
    scrubberUsagePoints: ['' , [Validators.required,Validators.pattern(this.decimalPattern)]],      
    });
    console.log(this.scrubberUsageForm)
    this.scrubberUsageForm.valueChanges.pipe(debounceTime(1000),distinctUntilChanged()).subscribe((value:any) => {
    console.log(value)
      this.scrubberUsageVal = value;
    })
  }
  editScrubberUsageEvent() {
   this.editScrubberUsage();
  }
  editScrubberUsage() {
    this.clearSidePanelData();
    this.openEditScrubberUsage = true; 
    this.toggleScrubberVal = this.getScrubberData?.currentScrubberUsage ? true : false;

    this.getToggleValue = this.getScrubberData?.currentScrubberUsage;
    console.log('getScrubberData?.currentScrubberUsage', this.toggleScrubberVal)
    this.vesselActivationDate = this.getScrubberData?.vesselActivationDate;
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate);
    if(this.getScrubberData?.hasPreviousChange){
      if(this.getScrubberData?.status.toLowerCase().trim() === 'upcomingchange'){
        this.editScrubberUsageVal = 'editScrubberUsageVal_3'
        this.showScrubberDiscardBanner = true;
        this.toggleScrubberVal = this.getScrubberData?.upcomingScrubberUsage ? true : false;
        this.upComingScrubberDate = this.getScrubberData?.upcomingEffectiveDate;
        this.upComingScrubberReason = this.getScrubberData?.upcomingReason ?? '';
        this.upcomingScrubberUsageReason = this.upComingScrubberReason;
        this.selectedUpcomingScrubberUsageDate = null;
        this.scrubberUsageForm.patchValue({
          scrubberUsagePoints: this.formatScrubberPointsForInput(this.getScrubberData?.upcomingScrubberPoints)
        });
      }
      else if(this.getScrubberData?.status.toLowerCase().trim() === 'pendingcalculation'){
        this.editScrubberUsageVal = 'editScrubberUsageVal_4';
        this.pendingScrubberUsageDateVal = this.getScrubberData?.currentEffectiveDate;
        this.pendingScrubberUsageReason = this.getScrubberData?.currentReason ?? '';
        this.pendingCurrentEffectiveDate = this.getScrubberData?.currentEffectiveDate;
        this.pendingCurrentReason = this.getScrubberData?.currentReason;
        this.scrubberUsageForm.patchValue({
          scrubberUsagePoints: this.formatScrubberPointsForInput(this.getScrubberData?.currentScrubberPoints)
        });
      }
      else if(this.getScrubberData?.status.toLowerCase().trim() === 'nochange'){
        this.editScrubberUsageVal = 'editScrubberUsageVal_1';
        this.noChangeScrubberDate = this.getScrubberData?.currentEffectiveDate;
        this.noChangeScrubberReason = this.getScrubberData?.currentReason;
        this.scrubberUsageReason = this.getScrubberData?.currentReason ?? '';
      }
    }else{
      this.editScrubberUsageVal = 'editScrubberUsageVal_1';
      this.noChangeScrubberDate = this.getScrubberData?.currentEffectiveDate;
      this.noChangeScrubberReason = this.getScrubberData?.currentReason;
      this.scrubberUsageReason = this.getScrubberData?.currentReason ?? '';
    }
  
  }
  get minSelectableDate(): Date {
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }

  get noChangeScrubberEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedScrubberUsageDate ?? this.noChangeScrubberDate);
  }

  get upcomingScrubberEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedUpcomingScrubberUsageDate ?? this.upComingScrubberDate);
  }

  get pendingScrubberEffectiveDate(): Date | null {
    return this.toPickerDate(this.pendingScrubberUsageDateVal);
  }

  get upcomingScrubberReasonValue(): string {
    return this.upcomingScrubberUsageReason || this.upComingScrubberReason || '';
  }

  private formatScrubberPointsForInput(value: unknown): string {
    return value === null || value === undefined || value === '' ? '' : String(value);
  }

  private toPickerDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const parsed = new Date(value as string);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  toggleScrubberUsage(e:any){
    console.log(e)
    this.scrubberUsageReason = '';
    this.selectedScrubberUsageDate = null;
    this.scrubberUsageForm.patchValue({
      scrubberUsagePoints: '',
    });
    this.scrubberPointsUsageErrorMsg = false;
    this.scrubberUsageForm.markAsUntouched(); 
    this.scrubberUsageForm.markAsPristine();
    this.toggleScrubberVal = e?.isSwitchActive;
    console.log(this.toggleScrubberVal)
    if(this.getToggleValue && !this.toggleScrubberVal){
      this.editScrubberUsageVal = 'editScrubberUsageVal_2_NoCase';
      console.log("yes to no",this.editScrubberUsageVal)
    } else if(!this.getToggleValue && this.toggleScrubberVal){
      this.editScrubberUsageVal = 'editScrubberUsageVal_2_YesCase';
      console.log("no to yes",this.editScrubberUsageVal)
    }else{
      this.editScrubberUsageVal = 'editScrubberUsageVal_1';
      console.log("else",this.editScrubberUsageVal)
    }
    
  }
  scrubberUsageDate(e:any){
    this.selectedScrubberUsageDate = e;
    this.noChangeScrubberDate = null;
  }
  scrubberUsagefieldValue(e:any){
    this.scrubberUsageReason = e;
    this.noChangeScrubberReason = '';
    if(this.scrubberUsageReason.length > 300){
      this.scrubberUsageReasonError = true;
    }else{
      this.scrubberUsageReasonError = false;
    }
  }
  upcomingScrubberUsageDate(e:any){
    this.selectedUpcomingScrubberUsageDate = e;
    this.upComingScrubberDate = null;
  }
  upcomingScrubberUsageValue(e:any){
    this.upcomingScrubberUsageReason = e;
    this.upComingScrubberReason = '';
    if(this.upcomingScrubberUsageReason.length > 300){
      this.upcomingScrubberUsageReasonError = true;
    }else{
      this.upcomingScrubberUsageReasonError = false;
    }
  }
  pendingScrubberUsageDate(e:any){
    this.pendingScrubberUsageDateVal = e;
    this.pendingCurrentEffectiveDate = null;
  }
  pendingScrubberUsageValue(e:any){
    this.pendingScrubberUsageReason = e;
    this.pendingCurrentReason = '';
    if(this.pendingScrubberUsageReason.length > 300){
      this.pendingScrubberUsageReasonError = true;
    }else{
      this.pendingScrubberUsageReasonError = false;
    }
  }
  updateScrubberUsage() {
    this.getScrubberUsageLoaderEvent.emit();
    if(this.getScrubberData?.hasPreviousChange){
      if(this.getScrubberData?.status.toLowerCase().trim() === 'nochange'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "scrubberUsage": this.toggleScrubberVal,
          "effectiveDate":this.datePipe.transform(this.selectedScrubberUsageDate ?? this.noChangeScrubberDate,"yyyy-MM-dd"),
          "reason": this.scrubberUsageReason,
          "scrubberPoints":Number(this.scrubberUsageVal?.scrubberUsagePoints)
        }
      }
      if(this.getScrubberData?.status.toLowerCase().trim() === 'upcomingchange'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "scrubberUsage": this.toggleScrubberVal,
          "effectiveDate":this.datePipe.transform(this.selectedUpcomingScrubberUsageDate ?? this.upComingScrubberDate,"yyyy-MM-dd"),
          "reason": this.upcomingScrubberUsageReason || this.upComingScrubberReason,
          "scrubberPoints":Number(this.scrubberUsageVal?.scrubberUsagePoints)
        }
      }
      if(this.getScrubberData?.status.toLowerCase().trim() === 'pendingcalculation'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "scrubberUsage": this.toggleScrubberVal,
          "effectiveDate":this.datePipe.transform(this.pendingScrubberUsageDateVal,"yyyy-MM-dd"),
          "reason": this.pendingScrubberUsageReason,
          "scrubberPoints":Number(this.scrubberUsageVal?.scrubberUsagePoints)
        }
      }
    }else{
      this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "scrubberUsage": this.toggleScrubberVal,
        "effectiveDate":this.datePipe.transform(this.selectedScrubberUsageDate,"yyyy-MM-dd"),
        "reason": this.scrubberUsageReason,
        "scrubberPoints":Number(this.scrubberUsageVal?.scrubberUsagePoints)
      }
    }
    this.vesselService.updateScrubberDetails(this.updatePayload).subscribe({
      next:(res:any)=>{
        if(res?.data?.updateScrubberUsageDetails?.success){
          this.updateScrubberUsageData = res?.data?.updateScrubberUsageDetails?.data;
          this.discardScrubberSuccess = false;
          this.getupdateScrubberUsage.emit(this.updateScrubberUsageData);
          this.toasterService.openToast('Success', res?.data?.updateScrubberUsageDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.updateScrubberUsageDetails?.message);
          this.errorScrubberUsageLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorScrubberUsageLoaderEvent.emit();
      }
    })
  }
  discardScrubberEvent(){
    this.openDiscardScrubberUsage = true;
    this.openEditScrubberUsage = false;
  }
  discardScrubberUsage(){
    this.getScrubberUsageLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isDiscarded": true
    }
    this.vesselService.discardScrubberDetails(payload).subscribe({
      next:(res:any)=>{
        if(res?.data?.discardScrubberUsageDetails?.success){
          this.discardScrubberUsageData = res?.data?.discardScrubberUsageDetails?.data;
          this.discardScrubberSuccess = true;
          this.getupdateScrubberUsage.emit(this.discardScrubberUsageData);
          this.toasterService.openToast('Success', res?.data?.discardScrubberUsageDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.discardScrubberUsageDetails?.message);
          this.errorScrubberUsageLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorScrubberUsageLoaderEvent.emit();
      }
    })
  }

  revertScrubberEvent(){
    this.openRestoreScrubberUsage = true;
    this.openEditScrubberUsage = false;
  }
  revertScrubberChanges(){
    this.getScrubberUsageLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      // "isRestoreToPreviousAction": true
    }
    this.vesselService.revertSCrubberDetails(payload).subscribe({
      next:(res:any)=>{
        if(res?.data?.revertScrubberUsageDetails?.success){
          this.restoreScrubberUsageData = res?.data?.revertScrubberUsageDetails?.data;
          this.getupdateScrubberUsage.emit(this.restoreScrubberUsageData);
          this.toasterService.openToast('Success', res?.data?.revertScrubberUsageDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.revertScrubberUsageDetails?.message);
          this.errorScrubberUsageLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorScrubberUsageLoaderEvent.emit();
      }
    })
  }
  cancelDiscardScrubberUsage(){
    this.openDiscardScrubberUsage = false;
    this.editScrubberUsage();
  }
  cancelScrubberRestore(){
    this.openRestoreScrubberUsage = false;
    this.editScrubberUsage();
  }
  closeScrubberSidePanel(){
    this.clearSidePanelData();
  }
  clearSidePanelData(){
    this.editScrubberUsageVal = '';
    this.selectedScrubberUsageDate = null;
    this.scrubberUsageReason = '';
    this.selectedUpcomingScrubberUsageDate = null;
    this.upcomingScrubberUsageReason = '';
    this.upComingScrubberDate = null;
    this.upComingScrubberReason = '';
    this.noChangeScrubberDate = null;
    this.noChangeScrubberReason = '';
    this.pendingScrubberUsageDateVal = null;
    this.pendingScrubberUsageReason = '';
    this.pendingCurrentEffectiveDate = null;
    this.pendingCurrentReason = null;
    this.scrubberUsageDate_1Val = null;
    this.scrubberUsageReasonfieldValue_1Val = '';
    this.scrubberUsageForm.patchValue({
      scrubberUsagePoints: '',
    });
    this.scrubberPointsUsageErrorMsg = false;
    this.scrubberUsageForm.markAsUntouched(); 
    this.scrubberUsageForm.markAsPristine()
  }
  goToPointsTab(){
    this.vesselService.$pointsMngEvent.next(true);
  }
  // openUnsavedModal(){
  //   this.openUnsavedScrubberUsage = true;
  //   this.openEditScrubberUsage = false;
  // }
  // leaveUnsavedChnages(){

  // }
  // cancelUnsavedChanges(){
  //   this.openUnsavedScrubberUsage = false;
  //   this.editScrubberUsage();
  // }

  scrubberUsageDate_1(e:any){
    console.log(e)
    this.scrubberUsageDate_1Val = e;
  }
  scrubberUsagefieldValue_1(e:any){
    console.log(e)
    this.scrubberUsageReasonfieldValue_1Val = e
  }
  handleFocusOutScrubberUsagePoints(e:any){
    this.scrubberPointsUsageErrorMsg = true;
  }

  isScrubberUsagePointsInputError(): boolean {
    return !!this.getScrubberUsagePointsInputErrorMessage();
  }

  getScrubberUsagePointsInputErrorMessage(): string {
    const control = this.scrubberUsageForm?.get('scrubberUsagePoints');
    if (!control?.invalid) {
      return '';
    }

    if (control.hasError('pattern') && control.dirty) {
      return this.scrubberUsagePointsPatternMessage;
    }

    if (control.hasError('required') && (control.dirty || (this.scrubberPointsUsageErrorMsg && control.touched))) {
      return this.scrubberUsagePointsRequiredMessage;
    }

    return '';
  }
  
}
